<template>
  <div class="ribbon-bar" v-if="displayItems && displayItems.length">
    <div class="ribbon-label">资讯</div>
    <div class="ribbon-marquee">
      <div class="ribbon-track">
        <div
          class="ribbon-item"
          v-for="(item, index) in loopItems"
          :key="`ribbon-${index}-${item.id || item.title}`"
          @click="openLink(item.url)"
        >
          {{ item.title || '资讯' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RibbonBar',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ribbonItems: []
    }
  },
  computed: {
    displayItems() {
      // 若组件内部已拉取数据，则优先使用；否则回退到外部传入
      return this.ribbonItems.length ? this.ribbonItems : this.items
    },
    loopItems() {
      // 复制一份用于无缝滚动
      return [...this.displayItems, ...this.displayItems]
    }
  },
  mounted() {
    this.fetchRibbonList()
  },
  methods: {
    openLink(url) {
      if (!url) return
      const normalized = url.startsWith('http') ? url : `https://${url}`
      window.open(normalized, '_blank')
    },
    fetchRibbonList() {
      if (!this.$api) return
      this.$api
        .get('/api/ribbon_list')
        .then((response) => {
          const data = response && response.data
          if (data && data.code === 200 && Array.isArray(data.data)) {
            this.ribbonItems = data.data
              .slice()
              .sort((a, b) => (a.sort || 0) - (b.sort || 0))
          } else {
            this.ribbonItems = []
          }
        })
        .catch((error) => {
          console.warn('获取资讯条失败:', error)
          this.ribbonItems = []
        })
    }
  }
}
</script>

<style scoped>
.ribbon-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 500;
  padding: 10px 16px;
  background: #cfe5df;
  color: #004e44;
  font-size: 26px;
  border-bottom: 1px solid #e6f3ec;
}

.ribbon-label {
  flex-shrink: 0;
  font-weight: 600;
}

.ribbon-marquee {
  overflow: hidden;
  flex: 1;
  position: relative;
  height: 32px;
}

.ribbon-track {
  display: inline-flex;
  gap: 32px;
  white-space: nowrap;
  animation: ribbon-scroll 18s linear infinite;
}

.ribbon-item {
  cursor: pointer;
  transition: color 0.2s;
}

.ribbon-item:active,
.ribbon-item:hover {
  color: #009e7a;
}

@keyframes ribbon-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>

